import styled from 'styled-components';

import {
  StyledTabs as BaseStyledTabs,
  StyledTab as BaseStyledTab,
  TabsContainer as BaseTabsContainer,
} from 'components/Tabs/styles';

/** `$flat` is audits-only: its tabs sit on the page ground and each tab paints its own cards. */
export const TabsContainer = styled(BaseTabsContainer)<{ $flat?: boolean }>`
  flex: 1;
  min-height: 0;
  padding: ${({ $flat }) => ($flat ? 0 : '10px 0 0')};
  border-radius: ${({ $flat }) => ($flat ? 0 : '8px')};
  border: ${({ $flat, theme }) => ($flat ? 'none' : `1px solid ${theme.palette.divider}`)};
  background: ${({ $flat, theme }) => ($flat ? 'transparent' : theme.palette.common.white)};
`;

export const StyledTabs = styled(BaseStyledTabs)<{ $flat?: boolean }>`
  margin-bottom: ${({ $flat }) => ($flat ? '16px' : 0)};
  border-bottom: ${({ $flat, theme }) => ($flat ? `1px solid ${theme.palette.grey[300]}` : 'none')};
  background-color: ${({ $flat, theme }) => ($flat ? 'transparent' : theme.palette.common.white)};
  padding: ${({ $flat }) => ($flat ? 0 : '0 20px')};

  .MuiTabs-scroller {
    border-bottom: ${({ $flat, theme }) => ($flat ? 'none' : `1px solid ${theme.palette.grey[300]}`)};
  }
`;

export const StyledTab = styled(BaseStyledTab)`
  min-height: unset;
`;

export const UserOverview = styled.div`
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
`;
